import React, { useEffect, useState } from "react";
import smartURL from "../../assets/images/smartURL.png";
import { getUserInfo } from "../../services/profile.service";
import { getActiveUserSubscriptionDetails } from "../../services/subscription.service";
import logo from "../../assets/images/smartLogoMain.png";

const MembershipCardHtmlComponent = () => {
  const [base64Image, setBase64Image] = useState(null);
  const [usePersonalInfo, setUserPersonalInfo] = useState("");
  const [userSubscriptionInfo, setUserSubscriptionInfo] = useState(null);
  const [name, setName] = useState("");
  const [base64Logo, setBase64Logo] = useState(null);


  useEffect(() => {
    const convertImageToBase64 = async () => {
      try {
        const userInfoDetails = await getUserInfo();
        if (userInfoDetails && userInfoDetails.length > 0) {
          const userInfo = userInfoDetails[0];
          setUserPersonalInfo(userInfo);
          setName(userInfo.name);
          const userSubscriptionDetails = await getActiveUserSubscriptionDetails();
          if (userSubscriptionDetails) {
            setUserSubscriptionInfo(userSubscriptionDetails);
          } 
        }
        const response = await fetch(smartURL);
        const blob = await response.blob();
        const reader = new FileReader();
        reader.onloadend = () => {
          setBase64Image(reader.result);
        };
        reader.readAsDataURL(blob);



        const logoResponse = await fetch(logo);
        const logoBlob = await logoResponse.blob();
        const logoReader = new FileReader();
        logoReader.onloadend = () => {
          setBase64Logo(logoReader.result);
        };
        logoReader.readAsDataURL(logoBlob);


      } catch (error) {
        console.error("Error converting smart URL image to Base64:", error);
      }
    };

    convertImageToBase64();
  }, []);

  const styledContent = {
    body: {
      backgroundColor: "white",
      color: "#212529"
    },
    container: {
      paddingRight: "0 !important",
      paddingLeft: "0 !important",
      border: "1px solid #6c757d",
      marginTop: "1.5rem"
    },
    
    membershipHeader: {
      paddingTop: "15px",
      paddingLeft: "10px",
      background: "linear-gradient(45deg, #3770d1, #3770d1) !important",
      color: "white",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    membershipHeaderCenter: {
      paddingBottom: "20px",
      background: "linear-gradient(45deg, #3770d1, #3770d1) !important",
      color: "white",
      textAlign: "center"
    },
    thankYouHeading: {
      color: "rgba(55, 112, 209) !important",
      fontWeight: "bold"
    },
    sectionInfo: {
      color: "#18b0f6 !important"
    },
    membershipDescription: {
      fontWeight: "normal !important"
    },
    membershipCardContainer: {
      maxWidth: "900px",
      margin: "0 auto",
      border: "3px dashed #666",
      overflow: "hidden",
      padding: "0",
      position: "relative",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
    },
    membershipCard: {
      width: "100%",
      backgroundColor: "white",
      position: "relative",
      borderRadius: "0px",
      background: "#f9f9f9"
    },
    cardRow: {
      padding: "0 !important",
      margin: "0 !important"
    },
    cardFront: {
      borderRight: "3px dashed #666 !important"
    },
    yearTag: {
      position: "absolute",
      top: "0",
      left: "45%",
      transform: "translateX(-50%)",
      backgroundColor: "#006699",
      color: "white",
      padding: "4px 20px",
      fontWeight: "bold",
      zIndex: "10",
      textAlign: "center",
      width: "80px"
    },
    memberTitle: {
      fontSize: "14px",
      color: "#006699",
      textAlign: "left !important",
      fontWeight: "500 !important"
    },
    memberName: {
      textAlign: "left !important"
    },
    memberDetails: {
      textAlign: "left !important",
      marginTop: "0.5rem"
    },
    qrCode: {
      width: "100px",
      height: "100px",
      background: "transparent !important"
    },
    cardFooter: {
      display: "flex",
      backgroundColor: "#006699",
      color: "white",
      padding: "10px 0 !important"
    },
    signatureSection: {
      borderRight: "1px solid white",
      padding: "0 10px"
    },
    signatureLine: {
      height: "15px",
      width: "70px",
      backgroundColor: "white"
    },
    presidentText: {
      fontSize: "10px",
      marginTop: "0.5rem"
    },
    slogan: {
      fontSize: "10px",
      textAlign: "right",
      color: "white"
    },
    logoCircle: {
      width: "50px",
      height: "40px",
      backgroundColor: "white",
      borderRadius: "50%",
      marginLeft: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#006699",
      fontWeight: "bold"
    },
    membershipDetails: {
      padding: "10px",
      backgroundColor: "#f0f8ff",
      borderRadius: "5px",
      marginTop: "15px",
      fontSize: "12px"
    },
    contactInfo: {
      fontSize: "12px",
      textAlign: "right",
      padding: "5px"
    },
    addressSection: {
      padding: "0 10px"
    },
    addressText: {
      fontSize: "10px",
      textAlign: "left"
    },
    websiteLink: {
      color: "#006699",
      fontWeight: "bold"
    },
    warningBanner: {
      backgroundColor: "#ffc107",
      color: "white",
      textAlign: "center",
      padding: "0.75rem",
      marginTop: "1rem"
    }
  };

  const membershipHtml = `
    <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>SMART Membership</title>
      </head>
      <body style="background-color: ${styledContent.body.backgroundColor}; color: ${styledContent.body.color}">
        <div class="container membership-card-wrap" style="padding-right: ${styledContent.container.paddingRight}; padding-left: ${styledContent.container.paddingLeft}; border: ${styledContent.container.border}; margin-top: ${styledContent.container.marginTop}">
          <div class="membership-header text-white d-flex justify-content-between align-items-center" style="padding-top: ${styledContent.membershipHeader.paddingTop}; padding-left: ${styledContent.membershipHeader.paddingLeft}; background: ${styledContent.membershipHeader.background}; color: ${styledContent.membershipHeader.color}; display: ${styledContent.membershipHeader.display}; justify-content: ${styledContent.membershipHeader.justifyContent}; align-items: ${styledContent.membershipHeader.alignItems}">
            <div class="h3 font-weight-bold">WITH SMART</div>
          </div>
          <div class="membership-header text-white text-center" style="padding-bottom: ${styledContent.membershipHeaderCenter.paddingBottom}; background: ${styledContent.membershipHeaderCenter.background}; color: ${styledContent.membershipHeaderCenter.color}; text-align: ${styledContent.membershipHeaderCenter.textAlign}">
            <h1 class="h2 font-weight-bold">You Can Achieve Great Things.</h1>
          </div>
          <div class="p-3 text-start ps-30">
            <h2 class="h2 font-weight-bold" style="color: ${styledContent.thankYouHeading.color}">Thank You for Your Membership!</h2>
          </div>

          <div class="row" style="padding-left: 20px; padding-bottom: 30px !important;">
            <div class="col-md-3">
              <p class="h5" style="color: ${styledContent.sectionInfo.color}">You are a member of the SMART Society</p>
            </div>
            <div class="col-md-8">
              <p class="h5" style="font-weight: ${styledContent.membershipDescription.fontWeight}">Below is a digital version of your membership card for easy access to your membership information!</p>
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="membership-card-container mt-2" style="max-width: ${styledContent.membershipCardContainer.maxWidth}; margin: ${styledContent.membershipCardContainer.margin}; border: ${styledContent.membershipCardContainer.border}; overflow: ${styledContent.membershipCardContainer.overflow}; padding: ${styledContent.membershipCardContainer.padding}; position: ${styledContent.membershipCardContainer.position}; box-shadow: ${styledContent.membershipCardContainer.boxShadow}">
            <div class="membership-card" style="width: ${styledContent.membershipCard.width}; background-color: ${styledContent.membershipCard.backgroundColor}; position: ${styledContent.membershipCard.position}; border-radius: ${styledContent.membershipCard.borderRadius}; background: ${styledContent.membershipCard.background}">
              <div class="row card-row" style="padding: ${styledContent.cardRow.padding}; margin: ${styledContent.cardRow.margin}">
                <!-- col-md-6 card-front start -->
                <div class="col-md-6 membership-card-front" style="border-right: ${styledContent.cardFront.borderRight}">
                  <!-- row start -->
                  <div class="row">        
                    <div class="col-md-8 member-info" style="padding: 15px;">
                      <div class="year-tag" style="position: ${styledContent.yearTag.position}; top: ${styledContent.yearTag.top}; left: ${styledContent.yearTag.left}; transform: ${styledContent.yearTag.transform}; background-color: ${styledContent.yearTag.backgroundColor}; color: ${styledContent.yearTag.color}; padding: ${styledContent.yearTag.padding}; font-weight: ${styledContent.yearTag.fontWeight}; z-index: ${styledContent.yearTag.zIndex}; text-align: ${styledContent.yearTag.textAlign}; width: ${styledContent.yearTag.width}">2025</div>
                      <div class="member-title" style="font-size: ${styledContent.memberTitle.fontSize}; color: ${styledContent.memberTitle.color}; text-align: ${styledContent.memberTitle.textAlign}; font-weight: ${styledContent.memberTitle.fontWeight}">
                        Member
                      </div>
                      <div class="member-name" style="text-align: ${styledContent.memberName.textAlign}">${name}</div>
                      <div class="member-details mt-2" style="text-align: ${styledContent.memberDetails.textAlign}">
                        ${userSubscriptionInfo ? userSubscriptionInfo.subscriptionType : ""}</br>
                       
                      </div>
                    </div>   
                    
                    <div class="col-md-4 qr-code mt-5" style="width: ${styledContent.qrCode.width}; height: ${styledContent.qrCode.height}; background: ${styledContent.qrCode.background}">
                      <!-- QR code container with pixelated pattern -->
                    </div>
                  </div>
                  
                  </br>
                  </br>
                  <!-- row end -->
                  <!-- footer start -->
                  <div class="card-footer" style="display: ${styledContent.cardFooter.display}; background-color: ${styledContent.cardFooter.backgroundColor}; color: ${styledContent.cardFooter.color}; padding: ${styledContent.cardFooter.padding}">
                    <div class="col-md-6 signature-section" style="border-right: ${styledContent.signatureSection.borderRight}; padding: ${styledContent.signatureSection.padding}">
                      <div style="height: ${styledContent.signatureLine.height}; width: ${styledContent.signatureLine.width}; background-color: ${styledContent.signatureLine.backgroundColor}"></div>
                      <div style="font-size: ${styledContent.presidentText.fontSize}"></br>2025 SMART President</div>
                    </div>
                     
                    <div class="col-md-6 smart-logo" style="display: flex; align-items: center; justify-content: flex-end; font-size: 12px; text-align: right;">
                      <div>
                        <div class="slogan" style="font-size: ${styledContent.slogan.fontSize}; text-align: ${styledContent.slogan.textAlign}; color: ${styledContent.slogan.color}">
                          Society for Microwaves, Antennas and Radar Technologies
                        </div>
                      </div>
                 <img src="${base64Logo}" alt="SMART Logo" class="logo-image" style="height: 40px;" />
                    </div>
                  </div>
                  <!-- footer end -->
                </div>
                <!-- col-md-6 card-front end -->

                <!-- col-md-6 card-back start -->
                <div class="col-md-6">
                  <!-- row start -->
                  <div class="row">
                    <div class="col-12">
                      <div class="d-flex justify-content-center pt-1">
                        <div>For membership information visit <span style="color: ${styledContent.websiteLink.color}; font-weight: ${styledContent.websiteLink.fontWeight}">smartforum.in</span></div>
                      </div>
                      <div class="row">
                        <div class="membership-details col-md-12 mt-0 mb-0" style="padding: ${styledContent.membershipDetails.padding};text-align:justify; background-color: ${styledContent.membershipDetails.backgroundColor}; border-radius: ${styledContent.membershipDetails.borderRadius}; margin-top: ${styledContent.membershipDetails.marginTop}; font-size: ${styledContent.membershipDetails.fontSize}">
                          SMART society is dedicated to fostering innovation and promoting collaboration in 
                          these advanced fields. It's objective is to bring together scientists, engineers, 
                          academicians, industry leaders, and young professionals on a shared platform to 
                          facilitate brainstorming, knowledge exchange, and a deeper understanding of 
                          pioneering radar technologies and national requirements.
                        </div>
                           <div class="contact-info col-md-12 mt-0 mb-0" style="font-size: ${styledContent.contactInfo.fontSize}; text-align: ${styledContent.contactInfo.textAlign}; padding: ${styledContent.contactInfo.padding}">
                          <strong>SMART Contact Center</strong> :</br>
                          9880107412</br>
                          smartforum2025@gmail.com
                        </div>
                     
                      </div>
                    </div>
                  </div>
                  <!-- row end -->
                  <!-- footer start -->
                  <div class="card-footer" style="display: ${styledContent.cardFooter.display}; background-color: ${styledContent.cardFooter.backgroundColor}; color: ${styledContent.cardFooter.color}; padding: ${styledContent.cardFooter.padding}">
                    <div class="col-md-6 address-section" style="padding: ${styledContent.addressSection.padding}">
                      <div style="font-size: ${styledContent.addressText.fontSize}; text-align: ${styledContent.addressText.textAlign}">
                        SMART
                       </br>
                       C V Raman Nagar, Bengaluru</br>
                        Karnataka, India 560093
                      </div>
                    </div>
                    <div class="col-md-6 smart-logo" style="display: flex; align-items: center; justify-content: flex-end; font-size: 12px; text-align: right;">
                      <div>
                        <div class="slogan" style="font-size: ${styledContent.slogan.fontSize}; text-align: ${styledContent.slogan.textAlign}; color: ${styledContent.slogan.color}">
                          Society for Microwaves, Antennas and Radar Technologies
                        </div>
                      </div>
                         <img src="${base64Logo}" alt="SMART Logo" class="logo-image" style="height: 40px;" />
                    </div>
                  </div>
                  <!-- footer end -->
                </div>
                <!-- col-md-6 card-back end -->
              </div>
            </div>
          </div>
          </br>
          <div class="bg-warning text-white text-center p-3 mt-3" style="background-color: ${styledContent.warningBanner.backgroundColor}; color: ${styledContent.warningBanner.color}; text-align: ${styledContent.warningBanner.textAlign}; padding: ${styledContent.warningBanner.padding}; margin-top: ${styledContent.warningBanner.marginTop}">
          </div>
        </div>
      </body>
    </html>
  `;

  return <div dangerouslySetInnerHTML={{ __html: membershipHtml }} />;
};

export default MembershipCardHtmlComponent;